import { toBerlinDateKey } from '@brimo/shared';

/** Input helpers of the financier forms: calendar days (Europe/Berlin) and German decimals („3,42"). */

export function todayKey(): string {
  return toBerlinDateKey(new Date());
}

/** `2026-09-24` + 7 → `2026-10-01` (calendar arithmetic in UTC, no time of day involved). */
export function addDaysKey(day: string, days: number): string {
  const [year, month, date] = day.split('-').map(Number) as [number, number, number];
  const value = new Date(Date.UTC(year, month - 1, date + days));
  return value.toISOString().slice(0, 10);
}

/**
 * A German decimal as typed („3,42", „3.42", „2,0 %", „10 Jahre") → number; empty → null; unreadable → NaN.
 * Thousands separators are not expected in rates and years.
 */
export function parseDecimalInput(text: string): number | null {
  const compact = text
    .replace(/[\s\u00a0\u202f%]/g, '')
    .replace(/p\.?a\.?$/i, '')
    .replace(/jahre?$/i, '')
    .replace(/j\.?$/i, '');
  if (compact === '') return null;
  const normalized = compact.replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(normalized)) return Number.NaN;
  return Number(normalized);
}

/** A number for an editable decimal field: 3.42 → „3,42". */
export function decimalInputText(value: number): string {
  return String(value).replace('.', ',');
}
